import { IEIDEasySignDocument } from "./../models/property/eideasy-sign-document.model";
import { IPropertyPictureModel } from "./../models/property/property-picture.model";
import axios, { AxiosPromise } from "axios";
import { GenericBaseParameter } from "../models/base-parameter";
import { GenericServices } from "./generic.services";
import Uri, { AI_URI } from "../common/uri/property-uri.constants";
import FileUri from "../common/uri/file-uri.constants";
import { itemStateConstant } from "../common";
import {
    IPropertyParameterModel,
    IPropertyListingModel,
    IPropertyCreativeObject,
    PropertyModel,
    IPropertyModel,
    IPropertyDocumentModel,
    IPropertyRoomModel,
    IPropertyRelationModel,
    IPropertySmartSuggestion,
    IPropertySmartSearchParameter,
    IPropertyVideoModel
} from "../models/property";
import {
    IPropertyDocumentRequestInfoModel,
    ISendPropertyDocumentRequestResponse
} from "../models/property/property-document-request-info.model";

import { ApiResponse } from "../models/app-configuration";
import { Listing } from "../models/listing-base-model";
import { DataHelper } from "../utils/data-helper";
import {
    MatchingPropertyRequest,
    MatchingPropertyResponse
} from "../models/property/property-matching-parameter.model";
import projectUri from "../common/uri/project-uri.constants";
//import { BELGIUM_LOCATION } from '../common/constants';
import {
    IClonePropertyRequest,
    IClonePropertyResponse
} from "../models/property/";
import { BoosterInfo } from "../models/property/property-booster.model";
import {
    MijnverhuisInfoResponseModel,
    MijnVerhuisRequestModel
} from "../models/property/property-mijnverhuis.model";
import {
    SmoovedInfoResponseModel,
    SmoovedRequestModel
} from "../models/property/property-smooved.model";
import {
    CertinergieInfoResponseModel,
    IKeuringPublishInfoRequest,
    CertiplusInfoResponseModel
} from "../models/property/property-keuring-platform.model";
import { KorfineRequestModel } from "../models/property/property-korfine.model";
import { GenerateTitleAiParams } from "../containers/property/property-edit/property-form/components/generate-title-ai/index.d";
export class PropertyServices extends GenericServices {
    /**
     *
     */
    constructor() {
        super();
    }
    verifyHeritageCancelTokenSource = axios.CancelToken.source();

    async initProperty(creativeObject: IPropertyCreativeObject): Promise<IPropertyModel> {
        const constantObject = {...creativeObject}
        try {
            const response: ApiResponse = await super.executeSelecting(constantObject, Uri.new);
    
            if (response.isSuccess) {
                const property: IPropertyModel = new PropertyModel(response.data["Property"]);
                delete property.Id;
                return property;
            } else {
                throw response.data;
            }
        } catch (error) {
            throw error;
        }
    }
    
    getListOfProperties(
        param: GenericBaseParameter<IPropertyParameterModel>,
        cancelTokenSource?: any
    ) {
        return super
            .executeSelectingPost(param, Uri.search, cancelTokenSource)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(
                          new Listing<IPropertyListingModel>(
                              "listOfProperties",
                              response.data
                          )
                      )
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    matchingAllPropertyIds(request: MatchingPropertyRequest) {
        var cloneRequest = DataHelper.deepClone<MatchingPropertyRequest>(
            request
        );
        cloneRequest.PageIndex = cloneRequest.PageSize = -1;
        cloneRequest.Fields = cloneRequest.OrderBy = "Id";
        cloneRequest.ViewMode = "Grid";

        return this.matchingProperties(cloneRequest)
            .then((response: MatchingPropertyResponse) =>
                Promise.resolve((response.Records || []).map(item => item.Id))
            )
            .catch(error => Promise.reject(error));
    }

    matchingProperties(request: MatchingPropertyRequest) {
        let url = Uri.matching.replace(
            ":demandId",
            request.DemandId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(
                          new MatchingPropertyResponse(response.data)
                      )
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    matchingCountProperties(demandId: number): Promise<number> {
        if (!demandId || demandId <= 0) {
            return;
        }

        let url = Uri.matchingCount.replace(":demandId", demandId.toString());

        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data.TotalRecords)
                    : Promise.reject(response.message)
            )
            .catch(ex => Promise.reject(ex));
    }

    getPropertyConfiguration() {
        return super
            .executeSelecting(undefined, Uri.config)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }
    getPropertyById(propertyId: number, loadTabs: string[] = []) {
        let path = Uri.detail;

        if (loadTabs.length > 0) {
            path += "?load-tab=" + loadTabs.join(",");
        }

        return super
            .executeSelectBy({ id: propertyId }, path)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(new PropertyModel(response.data));
                }
                return Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }
    quickSearchProperty<TResult>(query: string): AxiosPromise<TResult> {
        let path = Uri.quickSearch + "/" + query;
        return this.executeSelecting<string, TResult>(null, path);
    }

    listOfPropertyDocuments(
        param: number
    ): AxiosPromise<IPropertyDocumentModel[]> {
        let path = Uri.documents + "/" + param;
        return this.executeSelecting<string, IPropertyDocumentModel[]>(
            null,
            path
        );
    }

    getDocumentRequestInfo(
        param: number
    ): Promise<IPropertyDocumentRequestInfoModel> {
        const path = Uri.documentRequestInfo;
        return this.executeSelectBy({ id: param }, path)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    sendDocumentRequest(
        PropertyId: number,
        MailingInfo: Array<{ PersonId: number; MessageId: number }>,
        UserId?: number
    ): Promise<Array<ISendPropertyDocumentRequestResponse>> {
        const url = Uri.sendDocumentRequest.replace(
            ":id",
            PropertyId.toString()
        );
        const payload = { MailingInfo };
        if (UserId) {
            payload["UserId"] = UserId;
        }
        return this.executePost(payload, url)
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    /**
     * get all picture by property id
     */
    listOfPropertyPictures(
        param: number
    ): AxiosPromise<IPropertyPictureModel[]> {
        let path = Uri.pictures + "/" + param;
        return this.executeSelecting<string, IPropertyPictureModel[]>(
            null,
            path
        );
    }

    insertProperty(property: IPropertyModel, force: boolean = false) {
        delete property.IntermMandateReference;
        delete property.ProlongationTaskDate;
        // WA-3199 default some value
        // Fix bug always save when do nothing on financ tab.
        if (!property.Construction) {
            property.Construction = 0;
        }
        if (!property.CurrentRentalIncomeYield) {
            property.CurrentRentalIncomeYield = 0;
        }
        if (!property.PotentialRentalIncomeYield) {
            property.PotentialRentalIncomeYield = 0;
        }
        if (!property.CurrentRentalIncomeAnnual) {
            property.CurrentRentalIncomeAnnual = 0;
        }
        if (!property.CurrentRentalIncomeMonthly) {
            property.CurrentRentalIncomeMonthly = 0;
        }
        if (!property.PotentialRentalIncomeAnnual) {
            property.PotentialRentalIncomeAnnual = 0;
        }
        if (!property.PotentialRentalIncomeMonthly) {
            property.PotentialRentalIncomeMonthly = 0;
        }
        if (!property.FrontWidth) {
            property.FrontWidth = 0;
        }
        if (!property.GroundWidth) {
            property.GroundWidth = 0;
        }
        if (!property.Depth) {
            property.Depth = 0;
        }
        if (!property.RoomsExt) {
            property.RoomsExt = 0;
        }

        // SWA-470 set default VatValue when user check VAT checkbox
        if (property.IsVAT && !property.VatValue) {
            property.VatValue = 21;
        }

        let url = Uri.default;
        if (force) {
            url += "?force=true";
        }
        return super
            .executeCreating(this.parseProperty(property).next().value, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response);
            })
            .catch(error => Promise.reject(error));
    }

    updateProperty(
        property: IPropertyModel,
        originObject: IPropertyModel,
        config: any = {}
    ) {
        delete property.IntermMandateReference;
        delete property.ProlongationTaskDate;
        delete originObject.IntermMandateReference;
        delete originObject.ProlongationTaskDate;
        // WA-3199 Fix bug tab financ always save
        // Because VATBuilding is not update when edit in win app, it will always re-calculate to show, so always keep it at default
        if (property.VATBuilding) {
            property.VATBuilding = 0;
        }

        // WA-3199 Fix bug tab financ always save
        // Because CurrentRentalIncomeYield, PotentialRentalIncomeYield, will be change to undefined when edit property (object) in win app
        // So set it to default when undefined
        if (!originObject.CurrentRentalIncomeYield) {
            originObject.CurrentRentalIncomeYield = 0;
        }
        if (!originObject.PotentialRentalIncomeYield) {
            originObject.PotentialRentalIncomeYield = 0;
        }
        if (!property.PotentialRentalIncomeYield) {
            property.PotentialRentalIncomeYield = 0;
        }
        if (!property.CurrentRentalIncomeYield) {
            property.CurrentRentalIncomeYield = 0;
        }
        property.CheckingConfictData = property.ModifiedDate;
        originObject.CheckingConfictData = "";

        const parsedOrigin = this.parseProperty(originObject).next().value;
        const parsedProperty = this.parseProperty(property).next().value;

        return super
            .executeUpdating(
                originObject.Id,
                parsedOrigin,
                parsedProperty,
                Uri.default,
                config
            )
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response);
            })
            .catch(error => Promise.reject(error));
    }

    deleteProperty(ids: number[]) {
        if (ids.length <= 0)
            return Promise.reject("List of property ids must be more than 0");
        return super
            .executeDeletingMulti(ids, Uri.default)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }
    getContentByTabName(
        property: IPropertyModel,
        tabName: string,
        propertyName: string,
        extension: any = null
    ) {
        if (propertyName === "None") return Promise.resolve(property);
        if (property.Id > 0)
            if (Object.keys(property).indexOf(propertyName) === -1) {
                let url = Uri.loadContentByTabName;

                if (extension && extension.query) {
                    url += extension.query;
                }

                return super
                    .executeSelectBy({ id: property.Id, tab: tabName }, url)
                    .then((response: ApiResponse) => {
                        return response.isSuccess
                            ? Promise.resolve(response.data)
                            : Promise.reject(response.message);
                    })
                    .catch(ex => {
                        console.log(ex);
                        return Promise.reject(ex);
                    });
            } else {
                return Promise.resolve({
                    [propertyName]: property[propertyName]
                });
            }
        else {
            if (Object.keys(property).indexOf(propertyName) === -1) {
                return Promise.resolve({ [propertyName]: [] });
            } else
                return Promise.resolve({
                    [propertyName]: property[propertyName]
                });
        }
    }

    getQuickSearchProperties(ids: number[]) {
        if (ids.length <= 0)
            return Promise.reject("List of property ids must be more than 0");
        let url = Uri.getQuickSearchPropeties.replace(":ids", ids.join(","));
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    private *parseProperty(property: IPropertyModel) {
        const prod = DataHelper.deepClone<IPropertyModel>(property);
        if (prod.Rooms)
            prod.Rooms = property.Rooms.map(
                (room: IPropertyRoomModel) => this.getRoom(room).next().value
            ) as any;
        if (prod.Relations)
            prod.Relations = property.Relations.map(
                (relation: IPropertyRelationModel) =>
                    this.getRelation(relation).next().value
            ) as any;
        if (prod.Pictures)
            prod.Pictures = this.transformPictureRoomIds(
                prod.Pictures,
                property.Rooms
            );
        if (prod.Videos) {
            prod.Videos = property.Videos.map(
                (video: IPropertyVideoModel) => this.getVideo(video).next().value
            ) as any;
        }
        yield prod;
    }
    private transformPictureRoomIds(
        picture: IPropertyPictureModel[],
        rooms: IPropertyRoomModel[]
    ) {
        picture.forEach(pic => {
            delete pic.updateKey;
            pic.PictureRoomIds.forEach(room => {
                if (room.Id === 0) {
                    const mapRoom = rooms.find(x => x.TempId === room.TempId);
                    room.OrderNr = mapRoom ? mapRoom.OrderNr : undefined;
                    delete room.TempId;
                }
            });
        });
        return picture;
    }
    private *getRoom(room: IPropertyRoomModel) {
        const r = <IPropertyRoomModel>{
            StateId: room.StateId,
            ItemState: room.ItemState,
            DescriptionId: room.DescriptionId,
            FloorCoveringId: room.FloorCoveringId,
            FloorId: room.FloorId,
            Width: room.Width,
            Length: room.Length,
            Area: room.Area,
            OrderNr: room.OrderNr,
            CommentsNL: room.CommentsNL,
            CommentsFR: room.CommentsFR,
            CommentsEN: room.CommentsEN,
            Description: room.Description,
            PotIncome: room.PotIncome,
            Income: room.Income
        };
        if (room.Id) {
            r.Id = room.Id;
            r.PropertyId = room.PropertyId;
        }
        yield r;
    }

    private *getVideo(video: IPropertyVideoModel) {
        const result: IPropertyVideoModel = {
            Id: video?.Id,
            ObjectId: video?.ObjectId,
            VideoId: video?.VideoId,
            Type: video?.Type ?? 0,
            Order: typeof video?.Order === "number" ? video.Order : undefined,
            ItemState:
                typeof video?.ItemState === "number"
                    ? video.ItemState
                    : itemStateConstant.Unchanged
        };
        yield result;
    }

    private *getRelation(relation: IPropertyRelationModel) {
        const rel = <IPropertyRelationModel>{
            PersonId: relation.PersonId,
            RelationTypeId: relation.RelationTypeId,
            Comment: relation.Comment,
            IsMain: relation.IsMain,
            IsSendReport: relation.IsSendReport,
            PersonIndex: relation.PersonIndex,
            C21ContactListingId: relation.C21ContactListingId,
            Confirm: relation.Confirm,
            Time: relation.Time,
            IsSendAppointmentConfirmations:
                relation.IsSendAppointmentConfirmations,
            PersonName: relation.PersonName,
            PersonFirstName: relation.PersonFirstName,
            PersonCompanyName: relation.PersonCompanyName,
            PersonReference: relation.PersonReference,
            PersonEmail: relation.PersonEmail,
            PersonEmail2: relation.PersonEmail2,
            PersonEmail3: relation.PersonEmail3,
            PersonComment: relation.PersonComment,
            PersonCityName: relation.PersonCityName,
            RelationTypeNameNL: relation.RelationTypeNameNL,
            RelationTypeNameFR: relation.RelationTypeNameFR,
            RelationTypeNameEN: relation.RelationTypeNameEN,
            ItemState: relation.ItemState,
            PersonEmails: relation.PersonEmails,
            PersonPhones: relation.PersonPhones,
            RelationTypeNameDE: relation.RelationTypeNameDE,
            CompanyName: relation.CompanyName,
            PersonCountryId: relation.PersonCountryId,
            PersonLanguageId: relation.PersonLanguageId,
            PersonPostCode: relation.PersonPostCode,
            PersonStreet: relation.PersonStreet,
            PersonStreet2: relation.PersonStreet2,
            PhoneDesc3: relation.PhoneDesc3,
            PhoneDesc2: relation.PhoneDesc2,
            PhoneDesc1: relation.PhoneDesc1,
            PhoneDesc4: relation.PhoneDesc4,
            PhoneDesc5: relation.PhoneDesc5,
            PhoneDesc6: relation.PhoneDesc6,
            PhoneDesc7: relation.PhoneDesc7,
            PhoneDesc8: relation.PhoneDesc8,
            PhoneDesc9: relation.PhoneDesc9,
            PhoneDesc10: relation.PhoneDesc10,
            PersonHouseNumber: relation.PersonHouseNumber,
            PhoneNumber1: relation.PhoneNumber1,
            PhoneNumber2: relation.PhoneNumber2,
            PhoneNumber3: relation.PhoneNumber3,
            PhoneNumber4: relation.PhoneNumber4,
            PhoneNumber5: relation.PhoneNumber5,
            PhoneNumber6: relation.PhoneNumber6,
            PhoneNumber7: relation.PhoneNumber7,
            PhoneNumber8: relation.PhoneNumber8,
            PhoneNumber9: relation.PhoneNumber9,
            PhoneNumber10: relation.PhoneNumber10,
            PersonBoxNumber: relation.PersonBoxNumber,
            PersonVAT: relation.PersonVAT,
            PersonIDCardNumber: relation.PersonIDCardNumber,
            PersonBirthday: relation.PersonBirthday,
            PersonBirthplace: relation.PersonBirthplace,
            CompanyId: relation.CompanyId,
            StartCommercialisation: relation.StartCommercialisation,
            NeverSendMail: relation.NeverSendMail
        };
        if (relation.Id) {
            rel.Id = relation.Id;
            rel.PropertyId = relation.PropertyId;
        }
        yield rel;
    }

    populateToken2Condition(
        entity: GenericBaseParameter<IPropertySmartSearchParameter>,
        categoryType?: string
    ) {
        return super
            .executeCreatingWithParam<
                GenericBaseParameter<IPropertySmartSearchParameter>,
                any,
                any
            >(entity, { actionOn: categoryType || "map" }, Uri.token2Condition)
            .then((response: ApiResponse) => {
                if (response.isSuccess) return Promise.resolve(response.data);
                else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getListOfCriterias(param: IPropertySmartSuggestion) {
        return super
            .executeSelectingPost(param, Uri.smartSuggestion)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getListOfPropertyEnvironmentPoint(id: number) {
        if (id === undefined)
            return Promise.reject("List of property ids must be more than 0");
        let url = Uri.getPointObject.replace(":id", id.toString());
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getListOfProjectEnvironmentPoint(id: number) {
        if (id === undefined)
            return Promise.reject("List of property ids must be more than 0");
        let url = projectUri.poiObject.replace(":id", id.toString());
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPictureOfPropertyEnvironment(id: number) {
        if (id === undefined)
            return Promise.reject("List of property ids must be more than 0");
        let url = Uri.getPropertyEnvironmentPicture.replace(
            ":id",
            id.toString()
        );
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getFullUrlFromStorage(imageName: string) {
        if (imageName === undefined) return;
        let url = FileUri.getPublishPictureLink.replace(":fileName", imageName);
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    /** date format: yyyyMMdd */
    getPriceBaseIndex(payload: any) {
        let url = Uri.getPriceBaseIndex.replace("{id}", payload[0]);
        url = url.replace("{sigdate}", payload[1]);
        url = url.replace("{rentdate}", payload[2]);
        url = url.replace("{postcode}", payload[3]);
        url = url.replace("{typeprop}", payload[4]);
        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPropertyDetailViewMode(id: number, tabs?: string, excludeTabs?: string) {
        if (!id) {
            return;
        }

        const url = Uri.getPropertyDetailViewMode.replace(":id", id.toString());
        const payload = {
            tabs: tabs ? tabs : "*"
        };

        if (excludeTabs) {
            payload["exclude-tabs"] = excludeTabs;
        }
        return super
            .executeSelectingNotEncode(payload, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPropertyTabViewMode(id: number, tab?: string) {
        if (!id) {
            return;
        }

        let url = Uri.getPropertyTabViewMode.replace(":id", id.toString());
        url = url.replace(":tab", tab);

        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getSmoovedData(id: number) {
        if (!id) {
            return;
        }
        const url = Uri.getPropertySupplier.replace(":id", id.toString());

        return super
            .executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    resetMediaPubPlans(propertyId: number, data) {
        const url = Uri.resetMediaPubPlans.replace(
            ":id",
            propertyId.toString()
        );

        return super
            .executePost(data, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getMediaPubPlansLookup(propertyId: number, data) {
        const url = Uri.getMediaPubPlans.replace(":id", propertyId.toString());

        return super
            .executePost(data, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    generateMediaPubPlans(propertyId: number, data) {
        const url = Uri.generateMediaPubPlans.replace(
            ":id",
            propertyId.toString()
        );

        return super
            .executePost(data, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    regenerateMediaPubPlans(propertyId: number, data) {
        const url = Uri.regenerateMediaPubPlans.replace(
            ":id",
            propertyId.toString()
        );

        return super
            .executePost(data, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    changeInfoPubPlans(propertyId: number, action: string, data) {
        let url = Uri.changeInfoPubPlans.replace(":id", propertyId.toString());
        url = url.replace(":action", action);

        return super
            .executePost(data, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    clone(request: IClonePropertyRequest): Promise<IClonePropertyResponse> {
        let cloneUrl = Uri.clone.replace(":id", request.PropertyId.toString());

        return super
            .executeCreating(request, cloneUrl)
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response)
            )
            .catch(ex => Promise.reject(ex));
    }

    getBoosterInfo(ObjectId: number, IsProject: boolean): Promise<BoosterInfo> {
        let url = Uri.getBoosterInfo;

        return this.executePost(
            {
                ObjectId,
                IsProject
            },
            url
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    boostObject(ObjectId: number, IsProject: boolean): Promise<any> {
        let url = Uri.boostObject;

        return this.executePost(
            {
                ObjectId,
                IsProject
            },
            url
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    revertBooster(ObjectId: number, IsProject: boolean): Promise<any> {
        let url = Uri.revertBooster;

        return this.executePost(
            {
                ObjectId,
                IsProject
            },
            url
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    postRelation(
        propertyId: number,
        relation: IPropertyRelationModel
    ): Promise<any> {
        let url = Uri.addRelation.replace(":id", propertyId.toString());

        return this.executePost(
            {
                ...relation
            },
            url
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    deleteRelation(propertyId: number, ids: number[]): Promise<any> {
        let url = Uri.addRelation.replace(":id", propertyId.toString());

        return this.executeDeletingWith(
            {
                RelationIds: ids
            },
            url
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    getHeritagesByRegion(postCode): Promise<any> {
        const url = Uri.heritageList;

        return this.executeSelecting(
            {
                postCode
            },
            url,
            false
        )
            .then((response: ApiResponse) =>
                response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            )
            .catch(err => Promise.reject(err));
    }

    verifyPropertyHeritage(
        StreetName: string,
        HouseNumber: string,
        PostCode: string,
        CityName: string
    ): Promise<any> {
        if (this.verifyHeritageCancelTokenSource) {
            this.verifyHeritageCancelTokenSource.cancel("Cancel request");
            this.verifyHeritageCancelTokenSource = axios.CancelToken.source();
        }
        const url = Uri.verifyHeritage;
        const params = {
            StreetName,
            HouseNumber,
            PostCode,
            CityName
        };
        return this.executePost(params, url, {
            cancelToken: this.verifyHeritageCancelTokenSource.token
        })
            .then((res: ApiResponse) => {
                console.log("---", res);
                return res.isSuccess
                    ? Promise.resolve(res.data)
                    : Promise.reject(res.message);
            })
            .catch(err => Promise.reject(err));
    }

    getPublishMijnVerhuis(propertyId: number): Promise<any> {
        return super
            .executeSelectBy({ id: propertyId }, Uri.publishMijnVerhuis)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(
                        new MijnverhuisInfoResponseModel(response.data)
                    );
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    publishMijnVerhuis(request: MijnVerhuisRequestModel): Promise<any> {
        const url = Uri.publishMijnVerhuis.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    //Smooved
    getPublishSmooved(propertyId: number): Promise<any> {
        return super
            .executeSelectBy({ id: propertyId }, Uri.publishSmooved)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(
                        new SmoovedInfoResponseModel(response.data)
                    );
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    publishSmooved(request: SmoovedRequestModel): Promise<any> {
        const url = Uri.publishSmooved.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    checkSmooved(request: any): Promise<any> {
        const url = Uri.hasSmooved.replace(
            ":id",
            request.propertyId.toString()
        );
        return axios
            .get(url)
            .then(res => {
                return Promise.resolve(res.request.response);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    autoIndex(request: any): Promise<any> {
        return super
            .executeSelectingPost(request, Uri.autoIndex)
            .then(() => {
                return Promise.resolve(true);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    undoAutoIndex(request: any): Promise<any> {
        return super
            .executeSelectingPost(request, Uri.undoAutoIndex)
            .then(() => {
                return Promise.resolve(true);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getPublishCertinergie(propertyId: number): Promise<any> {
        return super
            .executeSelectBy({ id: propertyId }, Uri.publishCertinergie)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(
                        new CertinergieInfoResponseModel(response.data)
                    );
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    publishCertinergie(request: IKeuringPublishInfoRequest): Promise<any> {
        const url = Uri.publishCertinergie.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getPublishCertiplus(propertyId: number): Promise<any> {
        return super
            .executeSelectBy({ id: propertyId }, Uri.publishCertiplus)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(
                        new CertiplusInfoResponseModel(response.data)
                    );
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    publishCertiplus(request: IKeuringPublishInfoRequest): Promise<any> {
        const url = Uri.publishCertiplus.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    publishKeuringsPlatform(request: any): Promise<any> {
        let url = Uri.publishKeuringsPlatform.replace(
            ":id",
            request.propertyId.toString()
        );
        return super
            .executeSelectingPost(
                null,
                url.replace(":keuringOrderId", request.orderId)
            )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    generateEnergyPerformanceUrl(request: any): Promise<any> {
        let url = Uri.generateEnergyPerformanceUrl.replace(
            ":id",
            request.propertyId.toString()
        );
        return super
            .executeSelecting(
                null,
                url.replace(":supplierName", request.supplierName)
            )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getKeuringsPlatformOrders(request: any): Promise<any> {
        return super
            .executeSelecting(
                null,
                Uri.getKeuringsPlatformOrder.replace(
                    ":id",
                    request.Id.toString()
                )
            )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getInvoiceCommission(propertyId: number, params) {
        let url = Uri.invoiceCommission.replace(":id", propertyId.toString());
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(params, url)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }
    generateInvoiceNumber(propertyId: number) {
        let url = Uri.generateInvoiceNumber.replace(
            ":id",
            propertyId.toString()
        );
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }
    getPropertyChartData(propertyId: number) {
        let url = Uri.chartData.replace(":id", propertyId.toString());
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }
    checkingPropertyBrochure() {
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, Uri.checkingBrochure)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getDataBroChure(propertyId: number, module: number) {
        let url = `${Uri.getDataBrochure.replace(
            ":id",
            propertyId.toString()
        )}?module=${module}`;
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    postBrochure(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.postDataBrochure)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    deleteAll(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeDeletingWith(payload, Uri.deleteAll)
                .then((response: ApiResponse) => {
                    return response.isSuccess
                        ? resolve(response.data)
                        : reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    signDocument(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.signDocument)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    async getSupportSigningMethods() {
        try {
            const response = await super.executeSelecting(undefined, Uri.supportSigningMethods);
            return response.data;
        } catch (error) {
            return error
        }
    }

    getSignTagByDocumentId(documentId: number) {
        let url = Uri.getSignTagByDocumentId.replace(
            ":id",
            documentId.toString()
        );
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    eideasySignDocument(payload: IEIDEasySignDocument) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.eideasySignDocument)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }



    getSignDocumentOrder(payload) {
        const url = Uri.signDocumentOrder
            .replace(":propertyId", payload.PropertyId)
            .replace(":documentId", payload.DocumentId);
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getSignDocumentStatus(propertyId: number) {
        let url = Uri.getSignDocumentStatus.replace(
            ":id",
            propertyId.toString()
        );
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getSignDocumentStatusDetail(DocumentId: number) {
        let url = Uri.getSignDocumentStatusDetail.replace(
            ":id",
            DocumentId.toString()
        );
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getSignDocumentDisplayStatus() {
        let url = Uri.getSignDocumentDisplayStatus;
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    sendPaymentRequest(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.paymentRequest)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getDeclineDate(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.getDeclineDate)
                .then((response: ApiResponse) => {
                    if (
                        response.isSuccess &&
                        response.data &&
                        !response.data.ErrorMessage
                    ) {
                        return resolve(response.data);
                    }
                    return reject(
                        response.message || response.data.ErrorMessage
                    );
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    addCostFromRelation(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.addCostFromRelation)
                .then((response: ApiResponse) => {
                    return resolve(response.data);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getSignDocument(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.getSignDocument)
                .then((response: ApiResponse) => {
                    return resolve(response.data);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getEIDEasySignDocument(payload) {
        return new Promise((resolve, reject) => {
            return super
                .executeSelectingPost(payload, Uri.getEIDEasySignDocument)
                .then((response: ApiResponse) => {
                    return resolve(response.data);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    recallSignDocument(id) {
        return new Promise((resolve, reject) => {
            const url = Uri.recallSignDocument.replace("{id}", id);
            return super
                .executeSelectingPost(null, url)
                .then((response: ApiResponse) => {
                    return resolve(response.data);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    recallEIDEasySignDocument(payload: {doc_id: string}): Promise<any> {
        return super
            .executePost(payload, Uri.recallEIDEasySignDocument)
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }

    getOrdersSuppliers(payload: any): Promise<any> {
        let url = Uri.getOrdersSuppliers.replace(
            ":id",
            payload.propertyId.toString()
        );
        url = url.replace(":supplierName", payload.supplierName.toString());
        return super
            .executeSelecting(null, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getPropertiesRelation(propertyId: number) {
        let url = Uri.getPropertiesRelation.replace(
            ":id",
            propertyId.toString()
        );
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    publishKorfine(request: KorfineRequestModel): Promise<any> {
        const url = Uri.publishKorfine.replace(
            ":id",
            request.ObjectId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }

    publishRealSmart(request: any): Promise<any> {
        const url = Uri.publishRealSmart.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeSelectingPost(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    deleteRealSmart(request: any): Promise<any> {
        const url = Uri.deleteRealSmart.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeDeletingWith(request, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    cancelKorfine(request: any): Promise<any> {
        const url = Uri.cancelKorfine.replace(
            ":id",
            request.PropertyId.toString()
        );
        return super
            .executeDeletingWith(
                {
                    OrderId: request.orderId
                },
                url
            )
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(error => {
                Promise.reject(error);
            });
    }

    getPropertyPubtext(propertyId: number): Promise<any> {
        let url = Uri.getPropertyPubtext
            .replace(":id", propertyId.toString())
            .replace(":tab", "DescriptionOrPubText");
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getTranslateDescriptionInfoProperties(): Promise<any> {
        let url = Uri.translateProperties;
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    getTranslateDescriptionInfoProjects(): Promise<any> {
        let url = Uri.translateProjects;
        return new Promise((resolve, reject) => {
            return super
                .executeSelecting(undefined, url)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }

    postTranslateDescriptionInfoProjectById(request): Promise<any> {
        const url = Uri.postTranslateProject.replace(":id", request.id);
        return super
            .executeCreating(request.data, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            });
    }

    postTranslateDescriptionInfoPropertyById(request): Promise<any> {
        const url = Uri.postTranslateProperty.replace(":id", request.id);
        return super
            .executeCreating(request.data, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            });
    }

    postTranslateDescriptionInfoMultipleProperties(request): Promise<any> {
        return super
            .executeCreating(request, Uri.postTranslateMultipleProperty, {
                timeout:2000000
            })
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            });
    }

    generateTitleAi(payload: GenerateTitleAiParams): Promise<any> {
        const url = AI_URI.TITLE_GENERATION;

        return new Promise((resolve, reject) => {
            return super
                .executePost(payload, url)
                .then((response: ApiResponse) => {
                    console.log("response", response);
                    if (response.isSuccess) {
                        return resolve(response.data);
                    }
                    return reject(response.message);
                })
                .catch(error => {
                    console.log("error", error);
                    return reject(error);
                });
        });
    }

    getInvoicePrefill(propertyId: number): Promise<any> {
        const url = Uri.invoicePrefill.replace(":id", propertyId.toString());

        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    sendInvoice(propertyId: number, data: any): Promise<any> {
        const url = Uri.invoiceSend.replace(":id", propertyId.toString());

        return super
            .executeCreating(data, url, { skipRetry: true })
            .then((response: any) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                // Extract server error from response
                const serverError = this.extractServerError(response.data);
                return Promise.reject(serverError);
            })
            .catch(ex => {
                // Extract server error from axios error response
                const serverError = this.extractServerError(ex?.response?.data) || ex?.message || ex;
                return Promise.reject(serverError);
            });
    }

    private extractServerError(data: any): string {
        if (!data) return null;

        // Handle { errors: [{ Code: "...", Description: "..." }] } structure
        if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
            const errorMessages = data.errors.map((e: any) => {
                const code = e.Code || e.code;
                const description = e.Description || e.description || e.Message || e.message;

                if (code && description) {
                    return `${code}: ${description}`;
                }
                return code || description;
            }).filter(Boolean);

            if (errorMessages.length > 0) {
                return errorMessages.join(', ');
            }
        }

        // Fallback to other common error structures
        return data.msg || data.message || data.Message || null;
    }

    updateInvoiceNumber(propertyId: number, invoiceNumber: string): Promise<any> {
        const url = Uri.invoiceUpdateNumber.replace(":id", propertyId.toString());
        const data = { InvoiceNumber: invoiceNumber };

        return super
            .executeCreating(data, url)
            .then((response: any) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.errors || response.message);
            })
            .catch(ex => {
                return Promise.reject(ex);
            });
    }

    getInvoiceUrl(propertyId: number): Promise<{ Url?: string; errors?: Array<{ Code: string; Description: string }> }> {
        const url = Uri.invoiceUrl.replace(":id", propertyId.toString());

        return super
            .executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    // Check if response data contains errors array
                    if (response.data?.errors && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
                        return Promise.reject(response.data);
                    }
                    return Promise.resolve(response.data);
                }

                // Reject with the full response to preserve { errors: [...] } structure
                return Promise.reject(response);
            })
            .catch(ex => {
                // Handle error response with { errors: [...] } structure
                if (ex?.response?.data) {
                    return Promise.reject(ex.response.data);
                }
                return Promise.reject(ex);
            });
    }
}
